import Navigation from "@frog/source/models/Navigation.js"

import sizes from "@frog/source/data/sizes.js"

import App from "@frog/source/models/App.js"
import Director from "@frog/source/juice/Director.js"

import pixel from "@frog/source/views/utility/pixel.js"
import Geometry from "@frog/source/utility/Geometry.js"
import * as Objdict from "objdict"

import WorldTerrain from "@frog/source/views/WorldTerrain.view.js"
import Units from "@frog/source/views/Units.view.js"
import ActionArrowLayer from "@frog/source/views/ActionArrowLayer.view.js"
import ActionRangeLayer from "@frog/source/views/ActionRangeLayer.view.js"
import Particles from "@frog/source/views/Particles.view.js"
import Cursor from "@frog/source/views/Cursor.view.js"

export default function Stage(stage) {
    if(stage == undefined
    || App.game.encounter == undefined) {
        return
    }
    return {
        "key": "Stage",
        "width": "100%",
        "height": "100%",
        "position": {
            "x": -1 * (stage.camera || App.game.encounter.selection.camera).position.x,
            "y": -1 * (stage.camera || App.game.encounter.selection.camera).position.y,
        },
        "_": [
            WorldTerrain(stage),
            ActionRangeLayer(stage),
            ActionArrowLayer(stage),
            Units(stage),
            Particles(stage),
            Cursor(stage),
        ]
    }
}
